module.exports = __webpack_public_path__ + "static/media/calling.71b7693e.svg";